// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import classNames from 'classnames'
import { gql } from 'graphql-tag'
import React from 'react'
import { Mutation } from 'react-apollo'
import DateField from '../../common/dateField/DateField'
import { MultiSelect } from '../../common/select/Select'
import Textarea from '../../common/textarea/Textarea'
import { i18n } from '../index'
import type { Station } from '../station/stationTypes'
import withActiveStation from '../station/withActiveStation'
import type { Assignment } from './data'
import css from './taskListEditForm.css'
const UPDATE_ASSIGNMENT = gql`
  mutation UpdateAssignment($id: ID!, $assignment: UpdateAssignmentType!) {
    updateAssignment(assignmentId: $id, assignment: $assignment) {
      id
      subject
      description
      assignee {
        id
        name
      }
      assignees {
        id
        name
      }
      deadline
      status
      doneAt
      comment
    }
  }
`
type Props = {
  assignment: Assignment
  onClose: (...args: Array<any>) => any
  onSave: (...args: Array<any>) => any
  activeStation: Station
}
type FormData = {
  description: string
  userId: string
  deadline: string
  comment: string
}
type State = {
  formData: FormData
}
type Option = {
  label: string
  value: string | null | undefined
}

const userToOption = (user: any): Option => ({
  label: user.name,
  value: user.id,
})

const usersToOptions = (users: Array<any>): Array<Option> => users.map(userToOption)

@withActiveStation
class TaskListEditForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const { assignment } = this.props
    let userIds = []
    if (assignment.assignee) {
      userIds.push(assignment.assignee.id)
    }
    if (assignment.assignees) {
      userIds = userIds.concat(assignment.assignees.map((user) => user.id))
    }
    let usersSelected = []
    if (assignment.assignee) {
      usersSelected.push(userToOption(assignment.assignee))
    }
    if (assignment.assignees) {
      usersSelected = usersSelected.concat(usersToOptions(assignment.assignees))
    }
    this.state = {
      formData: {
        description: assignment.description,
        userIds: userIds,
        deadline: assignment.deadline,
        comment: assignment.comment || '',
      },
      ui: {
        usersSelected,
      },
    }
  }

  onCancel = () => {
    this.props.onClose()
  }
  onSubmit = (event: React.SyntheticEvent, mutation: (...args: Array<any>) => any) => {
    mutation({
      variables: {
        id: this.props.assignment.id,
        assignment: this.state.formData,
      },
    })
    event.preventDefault()
  }
  onCompleted = () => {
    this.props.onSave()
  }
  setFieldValue = (field: string, value: any) => {
    this.setState({
      formData: { ...this.state.formData, [field]: value },
    })
  }
  getFieldValue = (field: string) => {
    return this.state.formData[field]
  }
  setUserIds = (options: Array<Option>) => {
    const userIds = options.map((option) => option.value)
    this.setState({
      formData: { ...this.state.formData, userIds: userIds },
    })
    this.setState({
      ui: { usersSelected: [...options] },
    })
  }

  render() {
    const { activeStation } = this.props
    const users = activeStation.users || []
    return (
      <Mutation mutation={UPDATE_ASSIGNMENT} onCompleted={this.onCompleted}>
        {(mutation, { loading }) => (
          <div
            className={classNames(css.component, {
              [css.isLoading]: loading,
            })}
          >
            <form onSubmit={(event) => this.onSubmit(event, mutation)}>
              <div className={css.formContent}>
                <Textarea
                  label={i18n.t('taskList.editForm.descriptionLabel')}
                  placeholder={i18n.t('taskList.editForm.descriptionPlaceholder')}
                  value={this.getFieldValue('description')}
                  onChange={(e) => this.setFieldValue('description', e.target.value)}
                />
                <div className={css.row}>
                  <MultiSelect
                    className={css.userSelect}
                    label={i18n.t('taskList.createPage.assigneeLabel')}
                    placeholder={i18n.t('taskList.createPage.assigneePlaceholder')}
                    value={this.state.ui.usersSelected}
                    onChange={(options) => this.setUserIds(options)}
                    options={usersToOptions(users)}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti
                  />
                  <DateField
                    label={i18n.t('taskList.editForm.deadlineLabel')}
                    value={this.getFieldValue('deadline')}
                    onChange={(value) => this.setFieldValue('deadline', value)}
                    modifiers={{
                      disabled: {
                        before: new Date(),
                      },
                    }}
                    labelOnTop
                  />
                </div>
                <Textarea
                  label={i18n.t('taskList.editForm.commentLabel')}
                  placeholder={i18n.t('taskList.editForm.commentPlaceholder')}
                  value={this.getFieldValue('comment')}
                  onChange={(e) => this.setFieldValue('comment', e.target.value)}
                />
                <div className={css.loadingIndicator}>
                  <CircularProgress color='primary' />
                </div>
              </div>
              <div className={css.actions}>
                <Button onClick={this.onCancel}>{i18n.t('buttons.cancel')}</Button>
                <Button type='input' variant='contained' color='primary'>
                  {i18n.t('buttons.save')}
                </Button>
              </div>
            </form>
          </div>
        )}
      </Mutation>
    )
  }
}

export default TaskListEditForm
